module.exports = __webpack_public_path__ + "static/media/estamos_con_vos.1453ffa1.svg";